import { useEffect, useRef } from 'react';

import useBreakpoints, { isScreen } from '../useBreakpoints';

export type UseMobileRoomScrollIntoView = {
  isCalendarOpen?: boolean;
  isMobileSearchPanelModalOpen?: boolean;
  isLoading?: boolean;
};

/*
  On mobile, this hook scrolls the user to their selected room,
  after they've made a search.
*/
const useMobileRoomScrollIntoView = ({
  isCalendarOpen,
  isMobileSearchPanelModalOpen,
  isLoading,
}: UseMobileRoomScrollIntoView) => {
  const breakpoints = useBreakpoints();
  const isSmallScreen = isScreen(breakpoints)('xs', 'sm');

  const roomRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const isReady =
      isSmallScreen &&
      !isLoading &&
      !isCalendarOpen &&
      !isMobileSearchPanelModalOpen;

    if (!isReady) return;

    roomRef.current?.scrollIntoView({
      block: 'center',
    });
  }, [isLoading, isCalendarOpen, isMobileSearchPanelModalOpen, isSmallScreen]);

  const setSelectedRoomRef = (el: HTMLDivElement | null) => {
    roomRef.current = el;
  };

  return { setSelectedRoomRef };
};

export default useMobileRoomScrollIntoView;
